import React from "react";

export default (state, action) => {
  switch (action.type) {
    case "SET_TOKEN":
      return {
        token: action.payload,
      };
    case "SET_MY_ACCOUNT_INFO":
      return {
        myAccountInfo: action.payload,
      };
    default:
      return state;
  }
};
